import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/providers/ThemeProvider';

export function DarkModeToggle() {
  const { preferredMode, toggleMode } = useTheme();
  const isDark = preferredMode === 'dark';

  return (
    <button
      type="button"
      onClick={toggleMode}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="inline-flex items-center justify-center border-none bg-transparent cursor-pointer"
      style={{ minWidth: 44, minHeight: 44, color: 'inherit' }}
    >
      {isDark ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
}
